import _ from "lodash";
import { fetchCitiesByUF } from "@/api/ibge";

const state = {
  cities: [],
  isLoading: false,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchCitiesByUF({ dispatch, commit }, uf) {
    try {
      const cities = await fetchCitiesByUF(uf);

      commit("setCities", _.get(cities, "data", []));
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },
};

const mutations = {
  cleanState(state) {
    state.cities = [];
    state.isLoading = false;
  },

  setCities(state, cities) {
    state.cities = cities;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
